import { Divider, Stack, Tab, Tabs as TabList } from "@mui/material";
import useAuditStore from "./useAuditStore";
import useEpp2Started from "../Hooks/useEpp2Started";

export default function Tabs(){

    const {tab, setTab} = useAuditStore()

    const epp2Started = useEpp2Started();

    return (

        <Stack sx={{mb: 1}}>

            <TabList value={tab} onChange={(_,v) => setTab(v)}>

                <Tab label="Audit initial" value="initial" />

                <Tab label="Recommandations" value="recommendations" />

                <Tab label="Actions correctives" value="improvements" />

                {epp2Started && <Tab label="Audit final" value="final" />}

            </TabList>

            <Divider />

        </Stack>

    )
}